export default "__VITE_ASSET__lBqfCSkO__"